const MACHINE_STATUS_CONFIG = {
    charging: { bgColor: "#1AC69E", label: "Charging", textColor: "#ffffff" },
    discharging: { bgColor: "#FB5A00", label: "Discharging", textColor: "#ffffff" },
    faulted: { bgColor: "#990000", label: "Faulted", textColor: "#ffffff" },
    idle: { bgColor: "#8CBAFF", label: "Idle", textColor: "#ffffff" },
    inactive: { bgColor: "#A3A3A3", label: "Inactive", textColor: "#ffffff" },
    notreporting: { bgColor: "#808080", label: "Not Reporting", textColor: "#ffffff" },
    off: { bgColor: "#909090", label: "Off", textColor: "#ffffff" },
    transporting: { bgColor: "#F739E7", label: "Transporting", textColor: "#ffffff" },
    trickle: { bgColor: "#91F2E6", label: "Trickle", textColor: "#ffffff" },
    unavailable: { bgColor: "#9CA3AF", label: "Unavailable", textColor: "#ffffff" },
    working: { bgColor: "#2980B9", label: "Working", textColor: "#ffffff" }
};
const ESS_STATUS_CONFIG = {
    charging: { bgColor: "#1AC69E", label: "Charging", textColor: "#ffffff" },
    discharging: { bgColor: "#FB5A00", label: "Discharging", textColor: "#ffffff" },
    faulted: { bgColor: "#990000", label: "Faulted", textColor: "#ffffff" },
    idle: { bgColor: "#8CBAFF", label: "Idle", textColor: "#ffffff" },
    inactive: { bgColor: "#A3A3A3", label: "Inactive", textColor: "#ffffff" },
    notreporting: { bgColor: "#808080", label: "Not Reporting", textColor: "#ffffff" },
    off: { bgColor: "#909090", label: "Off", textColor: "#ffffff" },
    selfdischarge: { bgColor: "#8E44AD", label: "Self Discharge", textColor: "#ffffff" },
    trickle: { bgColor: "#91F2E6", label: "Trickle", textColor: "#ffffff" },
    unavailable: { bgColor: "#9CA3AF", label: "Unavailable", textColor: "#ffffff" }
};
const CHARGER_STATUS_CONFIG = {
    available: { bgColor: "#1AC69E", label: "Available", textColor: "#ffffff" },
    charging: { bgColor: "#1AC69E", label: "Charging", textColor: "#ffffff" },
    faulted: { bgColor: "#990000", label: "Faulted", textColor: "#ffffff" },
    finishing: { bgColor: "#2980B9", label: "Finishing", textColor: "#ffffff" },
    inoperable: { bgColor: "#D80000", label: "Inoperable", textColor: "#ffffff" },
    occupied: { bgColor: "#0066FF", label: "Occupied", textColor: "#ffffff" },
    preparing: { bgColor: "#8CBAFF", label: "Preparing", textColor: "#ffffff" },
    unavailable: { bgColor: "#9CA3AF", label: "Unavailable", textColor: "#ffffff" },
    unknown: { bgColor: "#808080", label: "Unknown", textColor: "#ffffff" }
};
export const getAssetStatusPill = (assetSourceType, assetStatus) => {
    if (!assetStatus)
        return null;
    // Normalise: lower-case, strip whitespace and underscores
    let key = assetStatus.toLowerCase().replace(/[\s_]+/g, "");
    // AC_Charging / DC_Charging are treated the same as Charging
    if (key === "accharging" || key === "dccharging")
        key = "charging";
    const type = assetSourceType?.toUpperCase();
    if (type === "MACHINE")
        return MACHINE_STATUS_CONFIG[key] ?? null;
    if (type === "ESS")
        return ESS_STATUS_CONFIG[key] ?? null;
    if (type === "CHARGER")
        return CHARGER_STATUS_CONFIG[key] ?? null;
    return null;
};
const REFRESHED_BADGE_TOKENS = {
    error: { bgColor: "#ffd2d2", className: "bg-[#ffd2d2] text-[#990000]", textColor: "#990000" },
    info: { bgColor: "#bce2ff", className: "bg-[#bce2ff] text-[#015394]", textColor: "#015394" },
    neutral: { bgColor: "#e0e0e0", className: "bg-[#e0e0e0] text-[#43485c]", textColor: "#43485c" },
    success: { bgColor: "#cae5c7", className: "bg-[#cae5c7] text-[#006618]", textColor: "#006618" },
    warning: { bgColor: "#ffd5bd", className: "bg-[#ffd5bd] text-[#9c3900]", textColor: "#9c3900" }
};
const REFRESHED_BADGE_VARIANTS = {
    available: "info",
    charging: "success",
    discharging: "warning",
    faulted: "error",
    finishing: "success",
    idle: "info",
    preparing: "warning",
    unavailable: "neutral",
    unknown: "neutral"
};
const getRefreshedBadgeVariant = (label) => {
    const key = label.toLowerCase().replace(/[\s_]+/g, "");
    return REFRESHED_BADGE_VARIANTS[key];
};
export const getRefreshedStatusPill = (pill) => {
    const badgeVariant = getRefreshedBadgeVariant(pill.label);
    if (!badgeVariant) {
        return pill;
    }
    const { bgColor, textColor } = REFRESHED_BADGE_TOKENS[badgeVariant];
    return { ...pill, bgColor, textColor };
};
export const getRefreshedStatusPillClassName = (label) => {
    const badgeVariant = getRefreshedBadgeVariant(label);
    return badgeVariant ? REFRESHED_BADGE_TOKENS[badgeVariant].className : "";
};
